import React from 'react'

const WorkerRefundPolicy = () => {
    return (
        <div>
            <div className="bg-[#F0FDF8] py-10 md:py-16 px-4">
                <div className="container mx-auto max-w-4xl">
                    <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 text-center leading-tight">
                        Worker Refund Policy
                    </h1>
                </div>
            </div>

            <div className="flex-grow container mx-auto pb-10 md:pb-16 px-4 sm:px-6">
                <div className="bg-white p-5 sm:p-8 md:p-12 max-w-4xl mx-auto">
                    <div>
                        <>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Maidly is a digital platform designed to support domestic workers by connecting them with homeowners seeking household services. To maintain transparency and fairness, this Refund Policy explains the circumstances under which workers may request a refund for payments made within the Maidly application.
                                </span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    This policy applies only to workers using Maidly and covers fees related to subscriptions, registrations, promotions, or other paid features offered through the app. As Maidly functions as a service-enabling platform, it does not guarantee job placement, work frequency, or income.
                                </span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    By making a payment through the Maidly app, workers acknowledge that they have read, understood, and agreed to this Refund Policy, along with Maidly’s Terms &amp; Conditions and Privacy Policy.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>1. Fees &amp; Payments</strong></p>
                            <p>&nbsp;</p>

                            <p><strong>1.1 Service Pricing</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    The price for cleaning services ("Service Fee") is displayed within the Maidly App at the time of booking. Paid features or subscriptions are displayed in the app before purchase. Prices may vary based on:
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Scope of Work:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Number of rooms, type of cleaning (Deep Clean vs. Regular), and home square footage.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Add-ons:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Extra tasks such as oven cleaning, balcony washing, or interior window cleaning.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Peak Timing:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Higher demand periods (weekends or holidays) may carry a "Peak Pricing" surcharge.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>1.2 Payment Authorization &amp; Capture</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Service Provider purchases a subscription, registration, or any paid feature within the Maidly app. Maidly may place a temporary hold on the selected payment method (e.g., credit card, UPI, or digital wallet). This hold is to verify that sufficient funds are available and to prevent accidental double charges. The worker’s account will not be officially debited until the transaction is successfully processed and the feature is activated in the app. If the payment fails for any reason, the worker will be notified immediately, and no subscription or feature access will be granted until the payment is successfully completed.
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Final Charge:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Your payment method will be formally charged only after the service is marked as "Complete" by the worker, or as otherwise specified during the checkout process.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>1.3 Taxes and Platform Fees</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Maidly charges workers a nominal platform fee for each paid feature, registration, or subscription. This fee covers the cost of the Maidly app technology, customer support, secure payment processing, and safety or insurance features that protect both workers and homeowners.
                                </span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    All prices displayed in the app are inclusive of applicable taxes, such as GST or VAT, unless explicitly stated otherwise. After successful payment, a digital invoice will automatically be generated and made available in the app under My Wallet / Payment History. Workers are encouraged to retain these invoices for personal record-keeping or tax purposes.
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Taxes:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}All fees are inclusive of applicable taxes (such as GST or VAT) unless stated otherwise. A digital invoice will be provided via the App or email after every successful booking.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>1.4 Payments to Service Providers</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The "No-Cash" Rule:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}To ensure safety and record-keeping, all payments must be made through the Maidly App.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Tipping:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Tips are not mandatory but are greatly appreciated by our partners. You may tip your worker directly through the App after the service is completed. 100% of the tip goes to the worker.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Off-Platform Transactions:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Attempting to pay a Worker directly in cash to bypass Maidly fees is a violation of our Terms and may result in the suspension of your account.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>1.5 Late Payments and Failed Transactions</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>If your primary payment method fails:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>You authorize us to attempt to charge any other payment method linked to your account.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>We reserve the right to suspend your account and any upcoming bookings until the outstanding balance is cleared.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>2. Refund Eligibility</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    To maintain a fair marketplace, Maidly follows strict criteria to determine if a booking is eligible for a refund. All refund requests are subject to an internal investigation by our Trust &amp; Safety team.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>2.1 Eligible for Full (100%) Refund</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>A worker is eligible for a refund of paid app features if-</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Service Non-Arrival:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}The Worker did not show up at the scheduled time and no replacement was provided.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Double Billing:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}A technical error resulted in the customer being charged twice for the same booking.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Advance Cancellation:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}The customer cancelled the booking more than 24 hours before the scheduled start time.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>2.2 Eligible for Partial Refund or Credits</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>A customer may be eligible for a partial refund or Maidly Wallet credits in these scenarios:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Incomplete Service:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}The worker arrived but had to leave early due to an emergency or was unable to finish specific tasks listed in the booking.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Significant Delay:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}The worker arrived more than 90 minutes late without prior communication or valid excuse.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Equipment Failure:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If the worker was responsible for providing supplies/equipment and they were non-functional, preventing a proper clean.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>2.3 The "Quality Guarantee" (Re-Clean over Refund)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Maidly operates on a "Fix it First" policy. If a customer is dissatisfied with the cleaning quality:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>They are not immediately eligible for a cash refund.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>They are eligible for a Free Remedial Clean.</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}A Service Provider will be sent back to address the specific "missed" areas at no extra cost.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>A refund will only be considered if the remedial clean also fails to meet the service standards.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>3. Non-Refundable Cases</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Refunds will not be provided for:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Job cancellations by homeowners</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Lack of job offers or work availability</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Request after 24 hours</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Payments made off-platform</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Attempted refunds for services already used or activated</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Change of mind after service activation</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Violation of Maidly’s Terms &amp; Conditions; to protect the livelihood of our Service Providers and the operational integrity of the platform, Maidly will not issue refunds in the following circumstances:</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>3.1 Reporting Delays</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The 24-Hour Rule:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Any complaint or refund request submitted more than 24 hours after the service completion time is strictly ineligible for a refund or a free re-clean.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Reasoning:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}After 24 hours, environmental factors, daily living, and foot traffic make it impossible to verify the original state of the cleaning.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>3.2 Home Access Issues</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Locked Doors:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If the Service Provider arrives and cannot gain access to the property (e.g., wrong security code provided, key not under the mat as promised, or no one answers the door).</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Waiting Period:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If the Service Provider waits for more than 20 minutes at the location and the Customer is unreachable. In this case, the full service fee is charged to compensate the worker for their time and travel.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>3.3 Subjective and Non-Standard Requests</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Personal Preference:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Issues based on personal taste (e.g., "The vacuum lines aren't straight enough" or "I don't like the scent of the floor cleaner").</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Unreachable Areas:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Failure to clean areas that are physically inaccessible, such as behind heavy furniture (that the cleaner is not authorized to move) or high ceilings beyond the reach of a standard ladder.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Pre-existing Damage:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Claims regarding the "cleanliness" of surfaces that are actually permanently stained, scratched, or worn out due to age.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>3.4 Customer Interference or Safety</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Work Obstruction:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If the Customer or other contractors (e.g., painters or plumbers) were working in the house at the same time, making it impossible for the Service Provider to clean effectively.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Hazardous Conditions:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If the Service Provider leaves the premises due to safety concerns (e.g., aggressive pets, lack of electricity/water, or abusive behavior from the Customer).</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>3.5 Third-Party Bookings</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Direct Payments:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Any payments made in cash or outside the Maidly App directly to a Service Provider are 100% non-refundable and non-trackable by Maidly. We cannot assist with disputes for transactions that occur off-platform.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>3.6 Force Majeure</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Utility Failure:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If the cleaning could not be completed because the Customer’s home lacked running water or electricity.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Act of God:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Sudden natural disasters, government-mandated lockdowns, or extreme weather that interrupts a service already in progress.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>4. Refund Request Process</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    We aim to resolve all disputes within 48 to 72 hours. To ensure a quick resolution, please follow the formal steps outlined below. For Apple or Google Play purchases, refunds are subject to the App Store / Google Play policies. Maidly can assist with documentation but final approval is at their discretion.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>4.1 Step 1: Submit Your Request</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>All requests must be submitted through the Maidly App or our official Help Center within 24 hours of the service.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>In-App:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Go to My Bookings &gt; Select Job &gt; Report an Issue.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Via Email:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Send a message to support@redqubes.com with your Booking ID in the subject line.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>4.2 Step 2: Provide Evidence</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We cannot process a refund based on a verbal description alone. You must provide:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Photos:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Clear, well-lit photos of the specific areas or items that did not meet our service standards.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Description:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}A brief explanation of what was missed or what went wrong (e.g., "The kitchen floor was not mopped").</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Time of Discovery:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Note when you noticed the issue.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>4.3 Step 3: Investigation</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Once submitted, our Trust &amp; Safety team will:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Review the Photos:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We compare your photos against the "Before &amp; After" photos.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Contact the Service Provider:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We speak with the Service Provider to get their version of events.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>GPS Verification:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We check the app's GPS logs to confirm the start and end times of the service.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>4.4 Step 4: Resolution Offer</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Depending on the findings, Maidly will offer one of the following:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Complimentary Re-clean:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}A cleaner will return to fix the issues (Our preferred resolution).</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Wallet Credit:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}A partial credit added to your Maidly account for your next booking.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Monetary Refund:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}A partial or full refund to your original payment method.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>4.5 Step 5: Processing the Refund</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>If a monetary refund is approved:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>It will be initiated immediately by our team.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Credit/Debit Cards:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Usually take 5–10 business days to reflect in your bank statement (this depends on your bank, not Maidly).</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Maidly Wallet:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Credits are available for use instantly.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>5. Refund Processing Time</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Once a refund is approved by the Maidly Trust &amp; Safety team, the time it takes for the funds to reach you depends entirely on the refund method selected. Refunds are not provided for delays or incomplete service caused by force majeure events such as natural disasters, utility failures, government-mandated lockdowns, or extreme weather.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>5.1 Maidly Wallet (Instant)</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Processing Time:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Within 1–2 hours of approval.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>How it works:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}The funds are added as a credit to your Maidly account. These credits can be used immediately to book your next cleaning. This is the fastest way to receive your funds.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>5.2 Credit and Debit Cards (Standard)</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Processing Time:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}5 to 10 Business Days.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Details:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Credit/Debit Card refunds may take 5–10 business days depending on your bank. Maidly initiates the refund immediately but cannot control bank processing times.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>5.3 Digital Wallets (UPI / Apple Pay / Google Pay)</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Processing Time:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}2 to 5 Business Days.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Details:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}These transactions generally move faster than traditional bank transfers but still require a verification window from the platform provider.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>5.4 Important Notes on Processing</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Business Days:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Processing times refer to Monday through Friday. Refunds are not typically processed by banks on weekends or public holidays.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Statement Appearance:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}In some cases, a refund may not appear as a new "deposit" but may instead "undo" the original charge. We recommend checking your statement for the original booking date to see if the transaction was reversed.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>6. App Store Payments</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    If you purchased a subscription, maid credits, or a single service using Apple In-App Purchase or Google Play Billing, the following rules apply. Because these transactions are handled by third-party app stores, Maidly does not have access to your credit card details or the ability to issue direct refunds.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>6.1 Refund Requests via Apple (iOS)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    All purchases via Apple or Google Play are subject to their refund policies. Maidly can provide documentation but cannot guarantee approval. Apple handles all refund requests for purchases made on iOS devices. Maidly cannot initiate these refunds on your behalf.
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Process:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You must request a refund through reportaproblem.apple.com.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Criteria:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Apple applies its own set of rules for refund eligibility. Once Apple approves the refund, they will notify us, and your service credits or booking will be cancelled accordingly.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>6.2 Refund Requests via Google Play (Android)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>For purchases made through the Google Play Store:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Within 48 Hours:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You can usually request a refund directly through the Google Play website.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>After 48 Hours:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Google typically directs users to contact the app developer (Maidly). In this case, we will review your request under our standard Refund Eligibility rules, but the actual technical refund may still be processed through the Google Play console.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>6.3 Subscription Cancellations</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>If you have a recurring "Weekly Cleaning" subscription billed through an App Store:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Managing Subscriptions:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You must cancel the subscription through your iPhone Settings (Apple ID) or Google Play Account Settings.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Effect of Deleting the App:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Simply deleting the Maidly App does not cancel your subscription. You will continue to be charged by the App Store until you manually cancel the subscription in your device settings.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>6.4 Price Differences</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Prices on the App Store may differ from our website due to platform fees or currency conversion. Maidly is not responsible for these surcharges.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>7. Changes to This Policy</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Maidly reserves the right to amend, modify, or update this Refund &amp; Cancellation Policy at any time to reflect changes in our business practices, service offerings, or legal obligations.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>7.1 Effective Date of Changes</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Any changes made to this policy will become effective immediately upon being posted within the Maidly App and on our official website. The "Last Updated" date at the top of this page will serve as the indicator of the most recent version.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>7.2 Notification of Major Updates</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    In the event of a "Material Change"—such as a significant increase in cancellation fees or a reduction in the refund window—we will make reasonable efforts to notify you:
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Via Push Notification:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}A direct alert through the Maidly App.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Via Email:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}An update sent to the email address linked to your account.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>In-App Banner:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}A notification displayed on the "Book Now" screen.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>7.3 Your Acceptance</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    By continuing to book services through Maidly after a policy update, you are providing your formal consent to the revised terms. If you do not agree with the updated policy, you should refrain from booking further services. We encourage all users and service providers to review this policy periodically to stay informed.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>7.4 Historical Bookings</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Please note that any refund or cancellation request will be governed by the version of the policy that was in effect at the exact time the booking was made, not the time the refund was requested.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>8. Contact Us</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    We believe in open communication. If you have questions about this Privacy Policy, your data rights, or how we handle your home’s security, please use the specific channels below to ensure your inquiry reaches the right department.
                                </span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    For questions regarding how we use your data, requests for data access, or updates to your personal information:
                                </span>
                            </p>
                            <p>
                                <strong>Email:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}support@redqubes.com</span>
                            </p>
                            <p>
                                <strong>Phone:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}+91 92576 52266</span>
                            </p>
                            <p>
                                <strong>Response Time:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}We aim to respond to all privacy-related inquiries within 24–48 hours.</span>
                            </p>
                        </>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WorkerRefundPolicy